export default __webpack_public_path__ + "static/media/ExploringLife.d7625f54.png";